/* eslint-disable no-console */

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import userReducer from './slices/userSlice';
import townshipReducer, { TownshipState } from './slices/townshipSlice';
import currentPermitReducer, {
  CurrentPermitState
} from './slices/currentPermitSlice';
import notificationReducer from './slices/notificationSlice'
import navigationReducer, { NavigationState } from './slices/navigationSlice';
import themeReducer, { ThemeState } from './slices/themeSlice';
import errorReducer, { ErrorState } from './slices/errorSlice';
import socketReducer from './slices/socketSlice';
import encryptDecryptTransform from './obfuscateTransform';
import cartReducer from './slices/cartSlice'
import constructionFormSlice from './slices/constructionFormSlice';
import plumbingSubcodeReducer from './slices/plumbingSubcodeSlice';
import foodBeverageFormReducer from './slices/foodAndBeverageFormSlice';

export interface UserDetails {
  [key: string]: any;
}

export interface RootState {
  user: {
    userDetails: UserDetails;
  };
  township: TownshipState;
  currentPermit: CurrentPermitState;
  navigation: NavigationState;
  theme: ThemeState;
  error: ErrorState;
  socket: any;
  cart: any;
  constructionFormSlice: any;
  plumbingSubcode:any;
  foodBeverageFormSlice:any;
}

// Combine the reducers properly
const rootReducer = combineReducers({
  user: userReducer,
  township: townshipReducer,
  currentPermit: currentPermitReducer,
  navigation: navigationReducer,
  theme: themeReducer,
  error: errorReducer,
  notifications: notificationReducer,
  socket: socketReducer,
  cart: cartReducer,
  constructionFormSlice: constructionFormSlice,
  plumbingSubcode: plumbingSubcodeReducer,
  foodBeverageFormSlice: foodBeverageFormReducer,
});

// Redux Persist configuration
const persistConfig: PersistConfig<RootState> = {
  key: 'root', // Key to store the state in localStorage
  storage, // Use localStorage or sessionStorage
  whitelist: [
    'user',
    'township',
    'currentPermit',
    'navigation',
    'theme',
    'error',
    'socket',
    'cart',
    'constructionFormSlice',
    'plumbingSubcode'
  ], // Define which slices to persist
  transforms: [encryptDecryptTransform],
};

// Apply persistReducer to the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const appStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable checks for persist
    }),
});

const persistor = persistStore(appStore); // Create persistor for rehydration

export { appStore, persistor };
